<template>
  <div class="empty-state">
    <i :class="icon" :style="iconStyle"></i>
    <p>{{ text }}</p>
    <el-button 
      v-if="showButton" 
      type="primary" 
      size="small" 
      class="create-first-btn" 
      :icon="buttonIcon" 
      @click="$emit('create')">
      {{ buttonText }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'el-icon-folder-opened' },
    text: { type: String, default: '暂无数据' },
    buttonText: { type: String, default: '创建第一个' },
    buttonIcon: { type: String, default: 'el-icon-plus' },
    showButton: { type: Boolean, default: true },
    iconSize: { type: String, default: '48px' }
  },
  computed: {
    iconStyle() {
      return {
        fontSize: this.iconSize,
        color: '#c0c4cc'
      }
    }
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
  font-size: 14px;
  text-align: center;
}

.empty-state p {
  margin: 16px 0;
  font-size: 14px;
  color: #909399;
}

.create-first-btn {
  margin-top: 8px;
  padding: 8px 20px !important;
  border-radius: 20px !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(19, 154, 165, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
}

.create-first-btn:hover {
  background: linear-gradient(135deg, #139AA5 0%, #139AA5 100%) !important;
}
</style>